<app-resp-popup-title>
  <span i18n="@@AnlageAPI_FacilityUpdate_Title">Update Facility</span>
</app-resp-popup-title>
<app-resp-popup-content>
  <div style="width: 600px; max-width: 72vw; position: relative">
    <form [formGroup]="form">
      <fieldset>
        <div class="row">
          <div class="col">
            <frm-text
              i18n-label="@@AnlageAPI_FacilityUpdate_Label"
              label="Label"
              formControlName="label"
            ></frm-text>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <frm-text
              i18n-label="@@AnlageAPI_FacilityUpdate_ContactEmail"
              label="Contact E-Mail"
              formControlName="contactEmail"
            ></frm-text>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <frm-wawi-building-type-select
              i18n-label="@@AnlageAPI_FacilityUpdate_BuildingType"
              label="Building Type"
              formControlName="buildingTypeID"
              [allowNone]="true"
            ></frm-wawi-building-type-select>
          </div>
          <div class="col" style="margin: auto">
            <frm-check
              i18n-label="@@AnlageAPI_FacilityUpdate_AppointmentRequired"
              label="Appointment Required"
              formControlName="appointmentRequired"
              i18n-title="@@AnlageAPI_FacilityUpdate_AppointmentRequired_Title"
              title="When tasks are created for this facility, the appointment is set to 'Required' for them."
            ></frm-check>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="location">
        <legend>
          <span
            i18n="@@AnlageAPI_FacilityUpdate_Location_Title"
            style="margin-right: 10px"
            >Location</span
          >
          <ctrl-btn
            icon="more_horiz"
            (click)="onFacilityLocationSelect()"
            style="margin-right: 10px"
          ></ctrl-btn>
        </legend>
        <div class="row">
          <div class="col">
            <frm-text
              i18n-label="@@AnlageAPI_FacilityUpdate_Location_Name"
              label="Name"
              formControlName="name"
            ></frm-text>
          </div>
        </div>
        <div class="row">
          <div class="col-9">
            <frm-text
              i18n-label="@@AnlageAPI_FacilityUpdate_Location_Street"
              label="Street"
              formControlName="street"
            ></frm-text>
          </div>
          <div class="col-3">
            <frm-text
              i18n-label="@@AnlageAPI_FacilityUpdate_Location_StreetNo"
              label="Street No."
              formControlName="streetNo"
            ></frm-text>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <frm-text
              i18n-label="@@AnlageAPI_FacilityUpdate_Location_PostalCode"
              label="Postal Code"
              formControlName="postalCode"
            ></frm-text>
          </div>
          <div class="col-9">
            <frm-text
              i18n-label="@@AnlageAPI_FacilityUpdate_Location_City"
              label="City"
              formControlName="city"
            ></frm-text>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <frm-wawi-country-select
              i18n-label="@@AnlageAPI_FacilityUpdate_Location_Country"
              label="Country"
              formControlName="countryID"
              (countrySelected)="onCountrySelected($event)"
            ></frm-wawi-country-select>
          </div>
        </div>
      </fieldset>
    </form>
    <app-spinner-overlay [visible]="loading"></app-spinner-overlay>
  </div>
</app-resp-popup-content>
<app-resp-popup-actions>
  <ctrl-btn-accept
    [disabled]="!canAccept()"
    (click)="onAccept()"
  ></ctrl-btn-accept>
  <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
</app-resp-popup-actions>
